import { useContext } from 'react';
import { I18nContext } from './i18n-context';

export function useI18n() {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n deve ser usado dentro de um I18nProvider');
  }
  return context;
}
